// src/lib/triageViewFacts.js
//
// Derived-view helpers for triage result pages that query against which
// flags already fired — structurally impossible to compute inside
// deriveFacts.ts, since facts are computed *before* runTriageFlags.ts ever
// runs, and don't belong in runTriageFlags.ts either (they're asked by a
// consumer, not authored by a flag). See tickets/023-snapshotredesign's D1.
//
// The other three "derived view" helpers from the same investigation
// (hasReportableForeignAssets, hasReportableNetWorth,
// foreignPropertyAssetMismatch) are genuine facts about the person, not flag
// lookups — those live in supabase/functions/_shared/tax-context/deriveFacts.ts
// and are read directly off `facts` by both triage result pages.

// modelo_720's own flag object, if it fired — used to decide whether the
// "What you own" / wealth zone has anything backed by an actual flag to show.
export function modelo720Flag(spainFlags) {
  return (spainFlags || []).find(f => f.id === 'modelo_720')
}

// Either wealth-tax flag (national ITSGF or regional Patrimonio) — mutually
// exclusive in runTriageFlags.ts, so at most one of these ever fires.
export function wealthFlag(spainFlags) {
  return (spainFlags || []).find(f => f.id === 'solidarity_tax' || f.id === 'wealth_tax')
}

// True when neither a Modelo 720 nor a wealth-tax flag fired — used to
// shorten/hide wealth-related copy when nothing in that zone is actually
// backed by a flag.
export function assetsLikelyDontApply(spainFlags) {
  return !modelo720Flag(spainFlags) && !wealthFlag(spainFlags)
}
